import { GET_BORDEREAU_DOWNLOAD_URL } from '../../constants/actions/policies';

export function getBordereauDownloadUrl(payload) {
    return {
        type: GET_BORDEREAU_DOWNLOAD_URL,
        payload,
    };
}
